const CheckBreakpoint = {
    breakPoints: null,
    init: () => {
       CheckBreakpoint.breakPoints = {
           xxxs: window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xxxs'),
           xxs: window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xxs'),
           xs: window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xs'),
           sm: window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-sm'),
           md: window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'),
           lg: window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg'),
           xl: window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xl'),
           xxl: window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xxl'),
           xxxl: window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xxxl'),
       }
    },
    check: (breakpoint) => {
        return window.matchMedia("(min-width: " + CheckBreakpoint.breakPoints[breakpoint] + ")").matches;
    },
    checkSmaller: (breakpoint) => {
        return window.innerWidth < parseInt(CheckBreakpoint.breakPoints[breakpoint]);
    }

}
const isJson = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
Object.defineProperty(Object.prototype, 'isE', {
    get() {
        return Object.getPrototypeOf(this) === Object.prototype &&
            Object.getOwnPropertyNames(this).length === 0 &&
            Object.getOwnPropertySymbols(this).length === 0
    }
});
Array.prototype.insert = function ( index, item ) {
    this.splice( index, 0, item );
};
Array.prototype.move = function (oldIndex, newIndex) {
    if (oldIndex < 0 || oldIndex >= this.length) return this;

    if (newIndex < 0) newIndex = 0;
    if (newIndex >= this.length) newIndex = this.length - 1;

    const [item] = this.splice(oldIndex, 1);
    this.splice(newIndex, 0, item);

    return this;
};
export {CheckBreakpoint, isJson}
